import { render, staticRenderFns } from "./quickBIDesign.vue?vue&type=template&id=ea428250&"
import script from "./quickBIDesign.vue?vue&type=script&lang=js&"
export * from "./quickBIDesign.vue?vue&type=script&lang=js&"
import style0 from "./quickBIDesign.vue?vue&type=style&index=0&id=ea428250&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports